<template><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0, .5)">
        <path d="M7.66047 11.799L14.7365 18.875C14.9031 19.0417 15.1703 19.0417 15.3369 18.875C15.5035 18.7084 15.5035 18.4412 15.3369 18.2746L8.56266 11.5004L15.3369 4.72615C15.5035 4.55954 15.5035 4.29235 15.3369 4.12574C15.2552 4.04401 15.1451 4 15.0383 4C14.9314 4 14.8214 4.04087 14.7396 4.12574L7.66361 11.2018C7.49701 11.3652 7.49701 11.6356 7.66047 11.799Z"/>
    </g>
</svg>
</template>